module.exports = __webpack_public_path__ + "53d4cc6d9cf4c83e07bcd40e8699fdc6.woff";